// extracted by mini-css-extract-plugin
module.exports = {"infoItem":"InfoItem_infoItem__1MYD9","whiteText":"InfoItem_whiteText__2RFfq"};